import http from "@/http/http"
import type { BusinessPointProfileVO } from "@/api"
// ==============================================
interface RuralSceneArgs {
  // 地区编码
  areaCode: string
  // 品牌ID
  brandId: string
  // 街道ID
  streetId: string
  // 页数
  page: number
  // 每页数量
  limit: number
  /**
   * 需传3个Boolean值，依次是住宿和餐饮业、农林牧渔业和制造业。
   * 不需要排序为null，升序为true，降序为false。默认为【false, null, null】
   */
  isAsc?: (boolean | null)[]
}

export interface RuralSceneListVO {
  // poiId
  poiId: string
  // 名字
  name: string
  // 地址
  address: string
  // 纬度
  lat: number
  // 经度
  lon: number
  // 住宿和餐饮业数量
  restaurantCount: number
  // 农林牧渔业数量
  agricultureCount: number
  // 制造业数量
  manufactureCount: number
}

interface RuralSceneListResult {
  list: RuralSceneListVO[]
  total: number
}

// 获取场景拓客列表-农村
export async function getRuralSceneList(params?: RuralSceneArgs): Promise<RuralSceneListResult> {
  try {
    const result = await http.post<RuralSceneListResult>(`/sceneExpand/scene/rural`, params)
    return result?.data
  } catch (error) {
    throw error
  }
}

export interface RuralProfileArgs {
  // 城市id
  areaCode: string
  // 品牌id
  brandId: string
  // 点位ID
  poiId: string
  // 纬度
  latitude: number
  // 经度
  longitude: number
  // 一级行业
  industryL1: string[]
  // 二级行业
  industryL2: string[]
  // 三级行业
  industryL3: string[]
  // 排序方式（SceneSortType）
  sortType: string[]
  // 是否正序
  isAsc: boolean[]
  // tag
  profileTag: string
}

export interface EcologyInfoItemVO {
  address: string
  capital: string
  capitalNum: number
  cooStatus: string
  industry: string
  latitude: number
  longitude: number
  name: string
  openingDate: string
}

interface RuralProfileResult {
  name: string
  dataDate: string
  ecologyInfo: EcologyInfoItemVO[]
  populationAnalysis: BusinessPointProfileVO
}

// 农村场景—画像分析
export async function ruralScenePointProfile(
  params: RuralProfileArgs,
): Promise<RuralProfileResult> {
  try {
    const { profileTag, ...others } = params
    const result = await http.post<RuralProfileResult>(
      `/sceneExpand/scene/rural/profile/${profileTag}`,
      others,
    )
    return result?.data
  } catch (error) {
    throw error
  }
}
